module.exports = __webpack_public_path__ + "img/icon-google-play.6a2d3ffa.svg";